import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import OSBrowserDetection from 'common/services/util/-RFC.OSBrowserDetection';

const _serviceDependencies = ['$state', '$rootScope', '$scope', '$window',
    'Auth', 'Util'];

/**
 * @ngdoc service
 * @name controllers.Forgot
 *
 * @description
 * Forgot password controller
 */
class Tfa {

    /**
     * @param  {any} $state
     * @param  {any} $rootScope
     * @param  {any} $scope
     * @param  {any} $window
     * @param  {any} Auth
     * @param  {any} Util
     */
    constructor($state, $rootScope, $scope, $window, Auth, Util) {

        this.Auth = Auth;
        this.Util = Util;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$window = $window;
        this.$scope.submitted = false;
        this.Auth.error = false;
        this.Auth.loading = false;
        this.$scope.tfaSetCookie = true;
        this.$scope.phone = '316';
        this.$scope.emailRegExp = this.Util.getEmailValidationRegExp();
        this.$scope.brandName = CWCONFIG.partnerConfig.name;

        /**
         * Redirects to login if email & password are undefined
         */
        if (typeof this.$rootScope.userCredentials === 'undefined') {

            this.$state.go('root.auth.login');
            return;

        }

        Mixpanel.send('ConnectWeb Auth Tfa Open', {
            Source: 'Direct',
        });

    }

    /**
     * @ngdoc controllers
     * @name controllers.Tfa#getTfaPayload
     * @methodOf controllers.Tfa
     *
     * @description
     * This method sets and returns TFA payload
     */
    getTfaPayload() {

        const username = this.$rootScope.userCredentials.email;
        const { password } = this.$rootScope.userCredentials;
        const grantType = this.$rootScope.userCredentials.grant_type || 'password';
        const { partner } = this.$rootScope.userCredentials;
        const { token } = this.$rootScope.userCredentials;

        // payload for normal login (username, password, grant_type)
        let tfaPayload = {
            grant_type: grantType,
            username,
            password,
        };

        // payload for Google, Facebook login or Apple (token, partner, grant_type)
        if (grantType === 'gg_auth' || grantType === 'fb_auth' || grantType === 'apl_auth') {

            tfaPayload = {
                grant_type: grantType,
                partner,
                token,
            };

        }

        return tfaPayload;

    }

    /**
     * @ngdoc controllers
     * @name controllers.Tfa#tfaAuth
     * @methodOf controllers.Tfa
     *
     * @description
     * sends 2FA authentication code to server and logins(if successful)
     */
    tfaAuth() {

        this.Auth.rememberTfa = this.$scope.tfaSetCookie;

        const tfaPayload = this.getTfaPayload();

        const tfaHeader = {
            'X-Avira-Otp': this.$scope.tfaCode,
            'X-Avira-Browser': this.$window.browserName,
            'X-Avira-Browser-Trusted': this.Auth.rememberTfa,
            'X-Avira-Os': OSBrowserDetection.getOSVersion(),
        };

        const formIsValid = this.$scope.tfaAuthLogin.$valid;

        this.$scope.submitted = true;

        if (formIsValid) {

            this.Auth.loading = true;
            this.Auth.tfaLogin(tfaPayload, tfaHeader);

        } else {

            this.Util.triggerAnimation('.error', 'animated shake');

        }

    }

    /**
     * @ngdoc controllers
     * @name controllers.Tfa#tfaResend
     * @methodOf controllers.Tfa
     *
     * @description
     * resends 2FA authentication code to user
     */
    tfaResend() {

        const tfaPayload = this.getTfaPayload();
        const isResendRequest = true;

        this.Auth.tfaLogin(tfaPayload, null, isResendRequest);

    }

}

_serviceDependencies.push(Tfa);

angular.module('controllers')
    .controller('Tfa', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/auth/tfa/tfa.js